module.exports = __webpack_public_path__ + "static/media/b4.1d9d640.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengqingsheng/b4.mp3
// module id = gDZD
// module chunks = 0